exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#report_main[data-v-1c3779dc]{\n    min-height:600px;\n}\n.ibox-title[data-v-1c3779dc]{\n    border-bottom: 1px solid #ddd;\n    margin-bottom: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c3779dc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/reports/uploadDetail.vue
// module id = kxIg
// module chunks = 1